<div class="subscription-form-container">
  <div class="header-form">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" class="backIcon" (click)="back()" (keypress)="back()" matTooltip="Annuler"
      appChangeColorTheme attribute="color">
    </fa-icon>

    <div class="title">{{ !formEdited ? "Ajouter une souscription" : "Modifier la souscription" }}</div>
    <button class="back" (click)="back()">Annuler</button>
  </div>

  <div class="form" [formGroup]="form">
    <div class="mandatory-fields-forms">
      <div class="created-on" *ngIf="formEdited">
        <strong>Créé le : </strong> <span>{{ formEdited?.createdOn | date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="username">
        <mat-form-field appearance="outline" class="lname">
          <mat-label>Nom</mat-label>
          <input id="" matInput formControlName="lastName" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="fname">
          <mat-label>Prénom</mat-label>
          <input id="" matInput formControlName="firstName" required />
        </mat-form-field>
      </div>

      <div class="contact">
        <mat-form-field appearance="outline" class="email">
          <mat-label>Email</mat-label>
          <input type="email" id="" matInput formControlName="email" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="phone">
          <mat-label>N° de téléphone</mat-label>
          <input type="number" id="" matInput formControlName="phoneNumber" required />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Ville</mat-label>
        <input id="" matInput formControlName="city" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nombre de participants</mat-label>
        <input type="number" id="" matInput formControlName="participantCount" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Article sélectionné</mat-label>
        <input type="text" id="" matInput formControlName="article" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sélectionner un formulaire</mat-label>
        <mat-select formControlName="formDefinition" (selectionChange)="onSelectFormDefinition($event)">
          <mat-option *ngFor="let formDef of formDefinitions" [value]="formDef">
            <strong>{{ formDef.key }}</strong> - <span>{{ formDef.name }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="personalized-fields">
      <app-field-group [fields]="fields" view="fill" (fieldsChange)="onFieldsChange($event)"></app-field-group>
    </div>
  </div>

  <div class="actions">
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <button mat-raised-button class="cancel" (click)="back()">Annuler</button>
      <button mat-raised-button [disabled]="form.invalid" class="save" (click)="save()">
        <span>{{ !formEdited ? "Ajouter" : "Sauvegarder"}}</span>
      </button>
    </ng-container>

    <ng-template #loadingTemplate>
      <mat-spinner diameter="50"></mat-spinner>
    </ng-template>
  </div>
</div>
